import Heading from '@/common/shared/heading'
import { Separator } from '@/common/ui/separator'
import DepositTable from '../DepositTable'
import { DepositTransactionResponse } from '../../types'
import { RefetchOptions } from '@tanstack/react-query'
import { CreateTransactionDialog } from '@/common/ui/table/data-table-processor-selector/CreateTransactionDialog'
import { PermissionKeys } from '@/modules/manage-member/mappers'
import useHasPermission from '@/common/hooks/useHasPermission'
import { DateRangePicker } from '@/common/components/DateRangePicker'
import DateRangeButtons from '@/common/components/DateRangeButtons'

interface DepositListingProps {
	data: DepositTransactionResponse['data']
	total: number
	onRefresh: (options?: RefetchOptions) => Promise<unknown>
	isLoading?: boolean
	onSort?: (columnId: string, order: 'asc' | 'desc' | undefined) => void
}

export default function DepositListing({
	data,
	total,
	onRefresh,
	isLoading,
	onSort,
}: DepositListingProps) {
	const hasWritePermission = useHasPermission(
		PermissionKeys.MANAGE_BANK_ACCOUNT,
	)

	return (
		<div className="space-y-4 px-4 sm:px-0">
			{/* Header Section - Mobile Responsive */}
			<div className="flex flex-col gap-4 sm:flex-row sm:items-start sm:justify-between">
				{/* Title and Action Button */}
				<div className="space-y-3 sm:space-y-4">
					<Heading title="รายการฝากเงิน" description="รายการฝากเงินทั้งหมด" />
					{hasWritePermission && <CreateTransactionDialog />}
				</div>

				{/* Date Controls - Mobile Responsive */}
				<div className="flex flex-col gap-3 sm:items-end sm:gap-4">
					<DateRangePicker />
					<DateRangeButtons />
				</div>
			</div>

			<Separator className="my-4 sm:my-6" />

			{/* Table Section */}
			<DepositTable
				data={data}
				total={total}
				onRefresh={onRefresh}
				isLoading={isLoading}
				onSort={onSort}
			/>
		</div>
	)
}
